<template>
  <div :id="dashboardId" :class="getClass(dashboardLayoutCard.dashboardCardTypeCode, dashboardLayoutCard.sequenceNumber)">
    <div class="dashboard-header">
      <div class="dashboard-title">
        <div class="dashboard-title-details">
          <a href="/analytics/explore" @click="$parent.logViewDetailsEvent(title)">            
            {{ title }}
          </a>
          <smart-center-link v-if="displayDashboard" page="Competitive Dashboard" location="Performance Trends" />
          <span class="ml-2"><modal-link :modal-id="title" :content-list="pageContentForDashboard"></modal-link></span>
        </div>
        <div class="dashboard-save-dashboard-card"  @click="$modal.show('performance-trends-save-chart-confirmation')"> 
              Save for Report
              <span class="m-1">
                <font-awesome-icon :icon="['fa', 'floppy-disk']" />
              </span>
        </div>
      </div>
      <div class="dashboard-widgets dashboard-performance-trends">
        <dashboard-card-dropdown label="Performance" :read-only="readOnly" :options="performance_options" :default-value="performance" @change="savePerformance"></dashboard-card-dropdown>
        <dashboard-card-dropdown label="Metric" :read-only="readOnly" :options="inputMetricOptions" :default-value="metricId" @change="saveMetric"></dashboard-card-dropdown>
      </div>
      <dashboard-card-expand :dashboard-id="dashboardId" />
    </div>
    <div class="dashboard-divider"></div>
    <div class="dashboard-card-body">
      <dashboard-card-skeleton v-if="!displayDashboard" />
      <div class="performance-trends-dashboard-chart" :style="dashboardChartStyle">
        <chart :options="options"></chart>
      </div>
      <div id="performance-trends-mini">
        <img :src="imageUrl" class="pdf-content-image-width hidden-dashboard-display"/>
      </div> 
    </div>
<!--  :updatedModalChartOptions.sync="options.series[0].data" -->        
    <dashboard-modal :modal-id="dashboardId" :chart="this.chart" :client-chart="this.clientChart" :dashboard-card-report-page-type-name="reportTypeName" :modal-title="title" :modal-chart-options="options" />
    <vue-modal :ref="modalName" :name="modalName" :width="350" :height="200">
      <save-chart :modal-name="modalName" button-label="Save for Report" :chart-title="this.chartTitle" :initial-client-chart="this.clientChart" @save="this.updateClientCharts" @closeModal="closeModal(this.modalName)"></save-chart>
    </vue-modal>
  </div>
</template>

<script>
import DashboardMixins from "../../mixins/DashboardMixins.vue";
import DashboardService from "../../services/dashboard.service";
import AdminService from "../../services/admin.service";
import ClientService from "../../services/client.service";
import SurveyService from "../../services/survey.service";
import Vue from "vue";
import SaveChart from "../chart/SaveChart.vue";
import DashboardCardSkeleton from "../../components/skeleton/DashboardCardSkeleton.vue";

import "echarts/lib/chart/heatmap";
import * as echarts from "echarts";

import $ from "jquery";
import { markRaw } from 'vue'; 
import DashboardCardDropdown from "./DashboardCardDropdown";

export default {
  name: "DashboardPerformanceTrends",
  mixins: [DashboardMixins],
  components: { DashboardCardDropdown, SaveChart, DashboardCardSkeleton },
  data() {
    return {
      title: "Performance Trends",
      clientLabelColor: "",
      modalName: "performance-trends-save-chart-confirmation",
      performance_options: [],
      performance: "WTP",
      metricId: "",
      metricDisplayTypeName: "",
      useMetricGrowth: false,
      usePercentage: true,
      performanceScatterSeries: {
        name: "Satisfaction",
        type: "line",
        smooth: false,
        showAllSymbol: true,
        symbol: 'pin',
        step: false,
        // symbolSize: 15,
        lineStyle: { width: 4 }, 
        z: 14,
        data: [],
        itemStyle: {
          color: "#2F5EB3"
        }
      },
      metricBarSeries: {
        name: "",
        type: "bar",
        //barWidth: 20,
        yAxisIndex: 1,
        itemStyle: {
          color: "#339966"
        },
        data: []
      },
      performanceBarSeries: {
        name: "",
        type: "bar",
        barGap: "-100%",
        barWidth: 1,
        itemStyle: {
          color: "#DCDCDC"
        },
        z: 12,
        data: []
      }
    };
  },
  props: {
    inputMetricOptions: {
      type: Array,
      default: function() {
        return [];
      }
    },    
    inputMetricId: {
      type: String,
      default: ""
    },
  },
  computed: {},
  mounted() {
// eslint-disable-next-line no-console    
    //console.log("DashboardPerformanceTrends.mounted");
    this.metricId = this.inputMetricId;
    this.chartTitle = "Performance Trends";
    this.chartTypeName = "performance-trends";
    this.containerId = "performance-trends-mini";
	  this.reportTypeName = "Dashboard - Performance Trends";
    this.dashboardSurveyGroupId = this.inputSurveyGroupId;
    this.dashboardUseEqualWeight = this.inputUseEqualWeight;
    //this.resetChart();
  },
  created() {},
  methods: {
    processSavedChartCriteria(criteria) {
      let criteriaParameters = criteria.split("=");
      let isMetric = criteriaParameters[0] == "metric" ? true : false;
  		if (isMetric){
        this.metricId = criteriaParameters[1];
  		}
      let isPerformance = criteriaParameters[0] == "performance" ? true : false;
  		if (isPerformance){
        let criteriaValue;
        try {
          criteriaValue = JSON.parse(criteriaParameters[1]);
        } catch (e) {
          criteriaValue = decodeURIComponent(criteriaParameters[1]).replace(/\+/g, " ");
        }           
        this.performance = criteriaValue;
  		}
      let isUseMetricGrowth = criteriaParameters[0] == "useMetricGrowth" ? true : false;
  		if (isUseMetricGrowth){
        this.useMetricGrowth = criteriaParameters[1];
  		}
      let isStartTimePeriodId = criteriaParameters[0] == "startTimePeriodId" ? true : false;
  		if (isStartTimePeriodId){
        this.startTimePeriodId = criteriaParameters[1];
  		}
      let isDashboardSurveyGroupId = criteriaParameters[0] == "dashboardSurveyGroupId" ? true : false;
  		if (isDashboardSurveyGroupId){
        this.dashboardSurveyGroupId = criteriaParameters[1];
  		}
      let isDashboardUseEqualWeight = criteriaParameters[0] == "dashboardUseEqualWeight" ? true : false;
  		if (isDashboardUseEqualWeight){
        this.dashboardUseEqualWeight = criteriaParameters[1];
  		}
    },
    buildUrlParams(client_id) {
      this.dashboardSurveyGroupId = this.inputSurveyGroupId;
      this.dashboardUseEqualWeight = this.inputUseEqualWeight;
      let params = this.buildBaseUrlParams();
      params.append("metric",this.metricId);
      params.append("useMetricGrowth",this.useMetricGrowth);
      params.append("performance",this.performance);
      params.append("startTimePeriodId",this.startTimePeriodId);
      return params;
    },      
    initChart(dynamicOptions) {
      //  https://echarts.apache.org/examples/en/editor.html?c=pictorialBar-dotted
      let chartDiv = $(".performance-trends-dashboard-chart")[0];
      this.chart = markRaw(echarts.init(chartDiv));
      let vm = this;
      this.chart.on('finished', () => {
        vm.saveImage();
      });
      this.options = DashboardService.getPerformanceTrendsOptions(echarts, ClientService.getClientColor());

      DashboardService.setIndividualSeries(this.performanceScatterSeries, 0, dynamicOptions);
      DashboardService.setIndividualSeries(this.metricBarSeries, 1, dynamicOptions);
      
      this.options.legend.data = DashboardService.setLegend(this.options.legend.data, dynamicOptions);
      $.extend(true, this.options, dynamicOptions);
      if (this.options.series[1] != null && this.options.series[1].itemStyle != null) {
        this.options.yAxis[1].axisLabel.color = this.options.series[1].itemStyle.color;
      }
      if (this.performance == "WTP") {
        let pricingPowerAxisLabel = {
          formatter: function(value, index) {
            return value.toFixed(1) + " %";
          }
        };
        $.extend(true, this.options.yAxis[0].axisLabel, pricingPowerAxisLabel);
      }
      if (this.performance == "Value Gap" || this.performance == "Emotions Gap Avg" || this.performance == "Satisfaction Gap Avg") {
        this.options.yAxis[0].min = 0;
        this.options.yAxis[0].inverse = true;
        let gapAxisLabel = {
          formatter: function(value, index) {
            return value.toFixed(1) ;
          }
        };        
        $.extend(true, this.options.yAxis[0].axisLabel, gapAxisLabel);
      } else {
        this.options.yAxis[0].inverse = false;
      }

      let yAxisLabel = DashboardService.getMetricFormatter(this.metricDisplayTypeName, this.usePercentage);
      $.extend(true, this.options.yAxis[1].axisLabel, yAxisLabel);
      this.options.yAxis[1].min = null;
      let yAxisMax  = {
        max: function (value) {
          return value.max + 1;
        }
      };
      $.extend(true, this.options.yAxis[1].max, yAxisMax);
      this.options.yAxis[1].max = null;
      
      if (this.autoGenerateChartRun == true){
        this.options.legend.top = 0;
        this.options.legend.show = true;
        this.options.grid.top = 25;
      }
      //this.printOptions();
      this.chart.setOption(this.options, true);
    },
    loadData: function() {},
    initialLoadData: async function() {
      // eslint-disable-next-line no-console      
      //console.log("DashboardPerformanceTrends.initialLoadData");
      this.buildPerformanceTrendsOptions();
      this.clientLabelColor = ClientService.getClientColor();
      this.displayDashboard = false;
      if (this.autoGenerateChartRun){
        this.processAutoGenerateChart();
      } else {
        this.metricId = this.inputMetricId;
      }   
      this.updateCard();
    },
    savePerformance: function(value) {
      this.performance = value;
      DashboardService.setDashboardSetting(this.$parent.defaultDashboardValues, DashboardService.DASHBOARD_PERFORMANCE_TRENDS_PERFORMANCE_SETTING_TYPE,this.performance, this.performance_options);
      this.updateCard();
    },
    saveMetric: function(value) {
      this.metricId = value;
      this.useMetricGrowth = false;
      DashboardService.setDashboardSetting(this.$parent.defaultDashboardValues, DashboardService.DASHBOARD_PERFORMANCE_TRENDS_METRIC_SETTING_TYPE, this.metricId, this.inputMetricOptions);
      this.updateCard();
    },
    updateCard: function() {
      // eslint-disable-next-line no-console
      //console.log("DashboardPerformanceTrends.updateCard  Performance Trends  ");
      this.resetChart();
      this.parseMetric();
      this.displayDashboard = false;
      this.$emit('loaded',false);
      let vm = this;
      setTimeout(function() {
        if (!vm.autoGenerateChartRun){
          vm.performance = DashboardService.getDashboardSetting(vm.$parent.defaultDashboardValues, DashboardService.DASHBOARD_PERFORMANCE_TRENDS_PERFORMANCE_SETTING_TYPE, vm.performance, vm.performance_options);
          vm.metricId = DashboardService.getDashboardSetting(vm.$parent.defaultDashboardValues, DashboardService.DASHBOARD_PERFORMANCE_TRENDS_METRIC_SETTING_TYPE, vm.inputMetricId, vm.inputMetricOptions);
        }
        if (typeof vm.metricId != "undefined" && vm.metricId.includes("growth")) {
          vm.useMetricGrowth = true;
        }
        try {
          DashboardService.getPerformanceTrends(vm.timePeriodId,vm.performance, vm.metricId, vm.useMetricGrowth, vm.startTimePeriodId ,vm.inputSurveyGroupId, vm.inputUseEqualWeight, vm.getPerformanceTrendsCallback, vm);
        } catch (e) {
          AdminService.displayErrorMessage("DashboardService.getPerformanceTrends", e, "admin", this);
          this.$emit('loaded',true);
        }
      }, 500);
    },
    getPerformanceTrendsCallback(response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.displayDashboard = true;
        let dynamicOptions = response.data.data.options;
        dynamicOptions.series[0].step = false;
        this.metricDisplayTypeName = response.data.data.metricDisplayTypeName;
        this.usePercentage = response.data.data.usePercentage;
        this.initChart(dynamicOptions);
        if (!this.autoGenerateChartRun){
          this.setupClientChart();
        }      
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
      this.$emit('loaded',true);
    },
    buildPerformanceTrendsOptions(){
      this.performance_options = [];
      this.performance_options.push({ name: SurveyService.getWTPLabel(), value: "WTP" });
      this.performance_options.push({ name: "Value Gap", value: "Value Gap" });
      this.performance_options.push({ name: "Emotions Gap Avg", value: "Emotions Gap Avg" });
      this.performance_options.push({ name: "Satisfaction Gap Avg", value: "Satisfaction Gap Avg" });
      this.performance_options.push({ name: "Importance Average", value: "Satisfaction" });
      this.performance_options.push({ name: "NPS", value: "NPS" });
    }
  },
  watch: {
    entrySurveyCode: function() {
      // eslint-disable-next-line no-console
      //console.log("DashboardPerformanceTrends::entrySurveyCode");
      this.resetChart();
    },
  }
};
</script>
